<div *ngIf="core.changingChannel" class="changing-channel">Changing Channel....</div>
<div class="messages noised-bg">
	<div class="message pinned" *ngIf="pinned" [ngClass]="pinned.role" tabindex="-1">
		<img *ngIf="pinned.avatar" [src]="pinned.avatar" alt=""/>
		<header>
			<span>
				{{ pinned.username }}
				<i class="material-icons" *ngIf="pinned.badge">{{ pinned.badge }}</i>
			</span>
			<small class="timeago">{{ pinned.timeago }}</small>
			<button class="unpin" (click)="discared_pin_id = pinned.id">
				<i class="material-icons">close</i>
			</button>
			<div class="actions" *ngIf="core.personality">
				<button *ngIf="core.personality.role == 'admin'" class="admin" (click)='core.smartSend({"cmd": "/unpin"})'>
					<i class="material-icons">push_pin</i> Unpin For All
				</button>
			</div>
		</header>
		<p class="message-content" [innerHTML]="pinned.text"></p>
	</div>
	<div class="message" *ngFor="let m of messages" [ngClass]="m.role" [class.is_deleted]="m.is_deleted" [class.sticky]="m.sticky" tabindex="-1" (dblclick)="toggleStick(m)">
		<img *ngIf="m.avatar" [class.premium]="m.premium" [src]="m.avatar" alt=""/>
		<header>
			<span (click)="insert_message_id(m)">
				{{ m.username }}
				<i class="material-icons" *ngIf="m.badge">{{ m.badge }}</i>
				<span class="private" *ngIf="m.whisper_to">
					<i class="material-icons">privacy_tip</i> private
				</span>
				<i *ngIf="m.premium" class="material-icons premium">verified</i>
			</span>

			<small *ngIf="m.rank && m.role != 'admin'" class="rank" (click)="core.parentMessage({ 'event' : 'rank_clicked', 'pid' : m.personality_id })">Rank: {{ m.rank }}</small>
			<small class="timeago">{{ m.timeago }}</small>
			<small class="flag" *ngIf="m.country_code" [innerHTML]="m.country_code"></small>
			<div class="actions" *ngIf="core.personality">
				<!--button><i class="material-icons">reply</i> Reply</button-->
				<button *ngIf="m.sticky" class="left" (click)="m.sticky = false"><i class="material-icons">sticky_note_2</i> Un-Stick</button>

				<ng-container *ngIf="(core.personality.role == 'admin' || ( core.personality.role == 'mod' && m.role != 'admin' && m.role != 'mod' )) && m.role != 'admin' && m.id" >
					<button (click)='core.smartSend({"ban": {"id":m.personality_id, "seconds":157680000}})' class="mod sensitive">
						<i class="material-icons">block</i> Perma
					</button>
					<button (click)='core.smartSend({"ban": {"id":m.personality_id, "seconds":86400}})' class="mod sensitive">
						<i class="material-icons">block</i> 1D
					</button>
					<button (click)='core.smartSend({"ban": {"id":m.personality_id, "seconds":3600}})' class="mod sensitive">
						<i class="material-icons">block</i> 1H
					</button>
					<button (click)='core.smartSend({"ban": {"id":m.personality_id, "seconds":300}})' class="mod sensitive">
						<i class="material-icons">block</i> 5M
					</button>
				</ng-container>
				<button *ngIf="core.personality.role == 'admin' && m.role == 'admin' && m.id" class="admin"
					(click)='core.smartSend({"cmd": "/pin <M-"+m.id+">"})'>
					<i class="material-icons">push_pin</i> Pin
				</button>
				<button *ngIf="m.id && ((core.personality.role != 'anon' && m.personality_id == core.personality.id) || core.personality.role == 'admin' || ( core.personality.role == 'mod' && m.role != 'admin' && m.role != 'mod' ))"
					[class.mod]="m.personality_id != core.personality.id"
					[class.admin]="m.role == 'admin' && m.personality_id != core.personality.id"
					(click)='core.smartSend({"delete_msgs": [m.id]})'>
					<i class="material-icons">delete</i> Delete
				</button>
			</div>
		</header>
		<p class="message-content" [innerHTML]="m.text" (click)="customClick($event)"></p>
	</div>
</div>
